module.exports = __webpack_public_path__ + "img/news01-M01.34b05627.png";